import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminPages from "@/pages/admin/AdminPages";

export const Route = createFileRoute("/admin/pages/")({
  component: () => (
    <ProtectedRoute>
      <AdminPages />
    </ProtectedRoute>
  ),
});
